import React from "react";
import Directory from "../../components/directory/directory";
import "./homepage.scss";

const HomePage = () => (
  <div className='homePage'>
    <Directory />
  </div>
);

export default HomePage;
